import { render, staticRenderFns } from "./ListAction.vue?vue&type=template&id=126dbc53&scoped=true"
import script from "./ListAction.vue?vue&type=script&lang=js"
export * from "./ListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dbc53",
  null
  
)

export default component.exports